export default __webpack_public_path__ + "static/media/analyst2.55d34701.png";